import orderBy from 'lodash/orderBy';
import type { GiftVm } from 'src/types/GiftVm';

export function sortGiftsByCreatedAtDesc(newGifts: Array<GiftVm>): Array<GiftVm> {
    return orderBy<GiftVm>(newGifts, ['createdAt'], ['asc']);
}
